import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHistoryRoute = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-history-icon lucide-history",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" }),
		/* @__PURE__ */ _jsx("path", { d: "M3 3v5h5" }),
		/* @__PURE__ */ _jsx("path", { d: "M12 7v5l4 2" })
	]
});
export default SvgHistoryRoute;
